import { SyntaxHighlighterApi } from '@appfolio/backstage-plugin-syntax-highlighter-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const syntaxHighlighterApiRef = createApiRef<SyntaxHighlighterApi>({
  id: 'plugin.syntax-highlighter.service',
});
